import { ActionDetailsModel } from './action-details.model';
import { AssociatedMaterialModel } from './associated-materials.model';
import { UploadMaterialMetadataModel } from './document-metadata.model';
import { HearingAccessModel } from './hearing-access.model';
import { LawyerModel } from './lawyer.model';
import { SpecialRequirementSelectionModel } from './special-requirment-selection.model';
export class HearingRequestDetailsModel {
  public id: string = '';
  public actionId: string = '';
  public hearingStatusCode: string = '';
  public justiceId: string = '';
  public justice: string = '';
  public isNew: boolean = false;
  public responsibleLawyer: LawyerModel = new LawyerModel();
  public requester: LawyerModel = new LawyerModel();
  public submittedDate: Date;
  public requestedHearingStartDate: Date;
  public requestedHearingEndDate: Date;
  public commencedByOrgUser: string = '';
  public comments: string = '';
  public readingTime: number = 0;
  public specialRequirements: boolean = false;
  public specialRequirementNotes: string = '';
  public duration: number = 0;
  public hearingMethod: string = '';
  public hearingMethodCode: string = '';
  public hearingMethodDescription: string = '';
  public hearingMethodContact: string = '';
  public decisionComments: string = '';
  public fileNumber: string = '';
  public remedySought: string = '';
  public contestedType: string = '';
  public urgentTimeRequired: number;
  public urgencyComments: string = '';
  public urgencyDates: string = '';
  public associatedHearingMaterials: AssociatedMaterialModel[];

  public isUrgent: boolean = false;
  public variedDeadlines = false;
  public confirmingLetter: UploadMaterialMetadataModel;
  public varyingDeadlineOrder: UploadMaterialMetadataModel;

  public specialRequirementsSelection: SpecialRequirementSelectionModel[];

  public action: ActionDetailsModel;
  public userHearingAccess: HearingAccessModel;
  public hearingHistory: HearingRequestDetailsModel[];

  constructor(init?: Partial<HearingRequestDetailsModel>) {
    Object.assign(this, init);
  }
}
